import { Theme, WithStyles } from "@material-ui/core";
import { bindActions, mockTheme } from "../utils/utils";
import * as React from "react";
import { ComponentClass } from "react";
import Grid from "@material-ui/core/Grid";
import { ClientActions, ClientState } from "../store/client";
import { SortDirection } from "@material-ui/core/TableCell";
import { IStore } from "../store";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../components/schemaForm";
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { ISubmitEvent, UiSchema } from 'react-jsonschema-form';
import Paper from '@material-ui/core/Paper';
import { getApi } from "src/api/ApiProvider";
import { TableClientComponent } from "src/components/TableComponent";

const styles = (theme: Theme) => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },
    routeSelector: {
        width: "100%",
        height: "100%"
    },
    buttons: {
        marginLeft: "auto",
    },
    abm: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit,
    }
});

const classesType = styles(mockTheme);

interface ClientsProps extends WithStyles<keyof typeof classesType> {
    actions: ClientActions;
    data: ClientState | any;
}

interface ClientsState {
    abm: {
        name: string;
        document: string;
        email: string;
        open: boolean
    },
    table: {
        data: any,
        sortBy: string,
        sortDirection: SortDirection
    },
    filterLoc: string,
    filter: string,
    pageNum: number,
    pageSize: number,
    totalItems: number;
    data: any;
    datos: any;
}

const schema: JSONSchema6 = {
    title: "Cliente",
    type: "object",
    required: ["name", "document", "email"],
    properties: {
        name: { type: "string", title: "Nombre" },
        document: { type: "string", title: "Documento" },
        email: { type: "string", title: "Correo electrónico", format: "email" }
    }
};

const uiSchema: UiSchema = {
    blendMode: {
        "ui:enumDisabled": [
            "multiply"
        ]
    }
};

class Clients extends React.Component<ClientsProps, ClientsState> {
    constructor(props: ClientsProps) {
        super(props);

        this.state = {
            abm: {
                name: "",
                document: "",
                email: "",
                open: false
            },
            table: {
                data: [],
                sortBy: "name",
                sortDirection: "desc"
            },
            filterLoc: '',
            pageNum: 0,
            pageSize: 5,
            totalItems: 0,
            data: null,
            datos:{},
            filter: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.showDialog = this.showDialog.bind(this);
        this.hideDialog = this.hideDialog.bind(this);
        this.getClientes = this.getClientes.bind(this);

        this.getClientes(this.state.pageNum, this.state.pageSize, '')
    }

    handleSubmit(e: ISubmitEvent<any>) {
        this.props.actions.add(e.formData);
        this.hideDialog();
    }

    sort(name: string) {
        return () => {
            this.setState({
                ...this.state,
                table: {
                    ...this.state.table,
                    sortBy: name,
                    sortDirection: "desc"
                }
            })
        }
    }

    hideDialog() {
        this.setState({
            abm: {
                ...this.state.abm,
                open: false
            }
        });
    }

    showDialog() {
        this.setState({
            abm: {
                name: '',
                email: '',
                document: '',
                open: true
            }
        });
    }

    getClientes(pageNum?: number, pageSize?: number, search?: string) {
        getApi().client().listPaginate(pageNum, pageSize, search).then(data => {
            console.log(data)
            this.setState({
                datos: data.page,
                totalItems: data.totalElements
            });
        })

    }
    setFilter = (filter: string) => {
        this.setState({ filter }, () => {
            this.getClientes(this.state.pageNum, this.state.pageSize, this.state.filter);
        });
    };

    setPageNum = (pageNum: number) => {
        this.setState({ pageNum }, () => {
            this.getClientes(this.state.pageNum, this.state.pageSize, this.state.filter);
        });
    };

    setPageSize = (pageSize: number) => {
        this.setState({ pageSize }, () => {
            this.getClientes(this.state.pageNum, this.state.pageSize, this.state.filter);
        });
    };
    render() {
        return (
            <Grid container spacing={24}>
                <Grid item sm={12} md={12}>
                    {/* <TableClientComponent
                        onFilterChange={(filter) => this.getClientes(this.state.pageNum, this.state.pageSize, this.state.filterLoc)}
                        onPageNumChange={(pageNum) => this.getClientes(pageNum, this.state.pageSize, this.state.filterLoc)}
                        onPageSizeChange={(pageSize) => this.getClientes(this.state.pageNum, pageSize, this.state.filterLoc)}
                        filter={this.state.filterLoc}
                        data={this.state.data}
                        totalItems={this.state.totalItems}
                        pageNum={this.state.pageNum}
                        pageSize={this.state.pageSize}
                    /> */}
                    <TableClientComponent
                        data={this.state.datos}
                        totalItems={this.state.totalItems}
                        pageNum={this.state.pageNum}
                        pageSize={this.state.pageSize}
                        filter={this.state.filter}
                        onFilterChange={this.setFilter}
                        onPageNumChange={this.setPageNum}
                        onPageSizeChange={this.setPageSize}
                        selectClient={false}
                        onSelection={() => console.log('')}
                    />
                </Grid>
                <Dialog open={this.state.abm.open}
                    maxWidth="md"
                    fullWidth={true}
                >
                    <Paper className={this.props.classes.abm}>
                        <EnhancedSchemaForm
                            schema={schema}
                            onSubmit={this.handleSubmit}
                            uiSchema={uiSchema}
                        >
                            <div>
                                <Button variant="contained" onClick={this.hideDialog}>
                                    Cancelar
                                </Button>
                                <Button variant="contained" color="primary" type="submit">
                                    Aceptar
                                </Button>
                            </div>
                        </EnhancedSchemaForm>
                    </Paper>
                </Dialog>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: ClientsProps) => ({
    ...ownProps,
    data: state.client
});

const styled = withStyles(styles as any)(Clients);
const connected = connect(mapStateToProps, bindActions(ClientActions))(styled);

export default connected as ComponentClass<Partial<ClientsProps>>;


// WEBPACK FOOTER //
// ./src/pages/client.tsx